import React from "react";
import { AlertCircle, UserCheck } from "lucide-react";
import type { ConversationAgentRow } from "../../types";

interface ConversationAgentTableProps {
  agents: ConversationAgentRow[];
}

export const ConversationAgentTable: React.FC<ConversationAgentTableProps> = ({ agents }) => {
  return (
    <div
      style={{
        background: "var(--bg-surface, #111827)",
        border: "1px solid var(--border-subtle, rgba(255,255,255,0.08))",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "var(--text-primary, #f9fafb)" }}>
            Por vendedor
          </h3>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "var(--text-muted, #9ca3af)" }}>
            Rendimiento operativo de conversaciones asignadas a vendedores humanos (universo derivaciones)
          </p>
        </div>
      </div>

      {agents.length === 0 ? (
        <div style={{ padding: "24px", textAlign: "center", color: "var(--text-muted, #9ca3af)" }}>
          <UserCheck size={32} style={{ margin: "0 auto 8px", opacity: 0.5 }} />
          <p style={{ margin: 0, fontSize: "14px" }}>Sin derivaciones en el rango.</p>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.08)", color: "var(--text-muted, #9ca3af)", textAlign: "left" }}>
                <th style={{ padding: "10px 12px" }}>Vendedor</th>
                <th style={{ padding: "10px 12px" }}>Pack</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Asignadas</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Con respuesta</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Mensajes en Telegram</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Envíos al cliente</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>MPT</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Compras</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Perdidas</th>
                <th style={{ padding: "10px 12px", textAlign: "right" }}>Monto</th>
              </tr>
            </thead>
            <tbody>
              {agents.map((ag, idx) => {
                const hasAlert = ag.mpt !== null && ag.mpt > 1.5;
                return (
                  <tr
                    key={`${ag.bot_id}-${ag.agent_name}-${idx}`}
                    style={{
                      borderBottom: "1px solid rgba(255,255,255,0.04)",
                      transition: "background 0.2s ease",
                    }}
                  >
                    <td style={{ padding: "10px 12px", fontWeight: 600, color: "var(--text-primary, #f9fafb)" }}>
                      {ag.agent_name}
                    </td>
                    <td style={{ padding: "10px 12px", color: "var(--text-muted, #9ca3af)", fontFamily: "monospace" }}>
                      {ag.bot_id}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right", fontWeight: 600 }}>
                      {ag.assigned_count.toLocaleString("es-CL")}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right" }}>
                      {ag.answered_count.toLocaleString("es-CL")}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right" }}>
                      {ag.msgs_agent_total.toLocaleString("es-CL")}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right" }}>
                      {ag.agent_deliveries_total.toLocaleString("es-CL")}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right" }}>
                      {ag.mpt !== null ? (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            color: hasAlert ? "#f59e0b" : "inherit",
                            fontWeight: hasAlert ? 700 : 500,
                          }}
                        >
                          {ag.mpt.toFixed(2)}
                          {hasAlert && (
                            <span title="MPT > 1.5 (mensajes fragmentados)">
                              <AlertCircle size={14} color="#f59e0b" />
                            </span>
                          )}
                        </span>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right", color: ag.converted_count > 0 ? "#10b981" : "inherit" }}>
                      {ag.converted_count}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right", color: ag.lost_count > 0 ? "#f87171" : "inherit" }}>
                      {ag.lost_count}
                    </td>
                    <td style={{ padding: "10px 12px", textAlign: "right", fontWeight: 600 }}>
                      {ag.total_amount > 0 ? `$${ag.total_amount.toLocaleString("es-CL")}` : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
